const ONE_SECOND_IN_MILLIS = 1000, ONE_MINUTE_IN_MILLIS = 60 * 1000, ONE_HOUR_IN_MILLIS = 60 * 60 * 1000, ONE_DAY_IN_MILLIS = 24 * 60 * 60 * 1000, ONE_WEEK_IN_MILLIS = 7 * 24 * 60 * 60 * 1000;
export const times = {
    ONE_SECOND_IN_MILLIS,
    ONE_MINUTE_IN_MILLIS,
    ONE_HOUR_IN_MILLIS,
    ONE_DAY_IN_MILLIS,
    ONE_WEEK_IN_MILLIS,
    DEVICE_ACTIVE: ONE_MINUTE_IN_MILLIS,
    DEVICE_RECENTLY_ACTIVE: 30 * ONE_MINUTE_IN_MILLIS,
    INVITATION_EXPIRY_OWNER: ONE_WEEK_IN_MILLIS,
    INVITATION_EXPIRY_MANAGER: ONE_HOUR_IN_MILLIS,
    INVITATION_EXPIRY_TRUSTED_POS: ONE_HOUR_IN_MILLIS,
    INVITATION_EXPIRY_POS: ONE_HOUR_IN_MILLIS,
    MINIMUM_VIDEO_EXPIRY: ONE_WEEK_IN_MILLIS,
    DEFAULT_VIDEO_EXPIRY: 12 * ONE_WEEK_IN_MILLIS,
    MAXIMUM_VIDEO_EXPIRY: 52 * ONE_WEEK_IN_MILLIS,
    VIDEO_EXPIRY_GRANULARITY: ONE_WEEK_IN_MILLIS,
    PING_INTERVAL: 22 * ONE_SECOND_IN_MILLIS,
    CANCELLATION_PERIOD: ONE_MINUTE_IN_MILLIS,
    TIME_OF_DAY_GRANULARITY: ONE_MINUTE_IN_MILLIS,
};
//# sourceMappingURL=times.js.map